import classnames from 'classnames2';
import React from 'react';

import { IBaseProps } from '../utils';

import styles from './Description.module.scss';

export interface IDescriptionProps extends IBaseProps {
  /** Defines the id attribute applied to the <p> tag */
  id?: string;
  /** Defines the font style of the description text */
  variant?: 'default' | 'condensed';
  /** If set, the maximum number of lines to render */
  maxLines?: number;
}

export const Description: React.FC<IDescriptionProps> = (props) => {
  const fontClass = props.variant === 'condensed' ? styles.condensed : '';
  let maxLinesClass = ''; // Default to nothing
  const maxLineStyle: React.CSSProperties = {}; // Default to nothing
  if (props.maxLines) {
    maxLinesClass = styles.maxLines;
    maxLineStyle.lineClamp = props.maxLines;
    maxLineStyle.WebkitLineClamp = props.maxLines;
  }

  return (
    <p
      id={props.id}
      className={classnames(styles.description, fontClass, props.className, maxLinesClass)}
      data-test={props.dataTest}
      style={maxLineStyle}
    >
      {props.children}
    </p>
  );
};
